"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.findMatchingAppt = exports.createApptTimeMachine = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _xstate = require("xstate");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _States = require("../../lib/constants/States");
var _Actions = require("../../lib/constants/Actions");
var _utils = require("../../lib/utils");
var _api = require("../../lib/api");
var _Facets = require("../../lib/constants/Facets");
var _ProviderLocations = require("../../components/ProviderLocations/ProviderLocations.utils");
var _WeekDayFilter = require("../../components/ApptTime/WeekDayFilter");
var _TimeFilter = require("../../components/ApptTime/TimeFilter");
/**
 * @param {Object} appt - an appointment returned from the `scheduling api`
 * @return {String}
 */
const keyFromAppointment = appt => [appt.start_datetime, appt.duration_minutes, appt.provider_id, appt.location_id].join(':');

/**
 * Merge two lists of appointments and returns a list of
 * unique appointments
 * @param {Array} appointments
 * @param {Array} nextAppointments
 * @return {Array}
 */
const mergeAppointments = (appointments, nextAppointments) => {
  const existing = new _set.default((0, _map.default)(appointments).call(appointments, keyFromAppointment));
  const uniq = (0, _filter.default)(nextAppointments).call(nextAppointments, appt => !existing.has(keyFromAppointment(appt)));
  return (0, _concat.default)(appointments).call(appointments, uniq);
};

/**
 * Returns params used for the scheduling api call
 * @param {Object} ctx - machine context
 * @return {Object}
 */
const schedulingParamsFromCtx = (ctx, ev) => ({
  provider: ctx.provider,
  location_ids: ctx.query.locationIds,
  period_start: ev.periodStart || ctx.query.periodStart || ctx.jumpedToDate || new Date(),
  purpose: ctx.query.purpose.name,
  patient_relationship: ctx.query.patientRel,
  role: ctx.query.role,
  visibility: ctx.query.visibility
});

/**
 * Returns a matching appointment based on ctx.locationId and ctx.periodStart
 * @param {Object} ctx - machine context
 * @param {Object} ev - event triggered by the completion of the availability/scheduling api call
 * @param {Array} ev.data - array of appointments from the availability/scheduling api call
 * @return {Object} - a matching appointment, if one found
 * @return {Null} - if no matching appointment is found
 */
const findMatchingAppt = (ctx, ev) => {
  const {
    locationId,
    periodStart
  } = ctx;
  const appointments = ev.data.schedRes;
  return (0, _find.default)(appointments).call(appointments, _ref => {
    let {
      location_id,
      start_datetime
    } = _ref;
    return location_id.toString() === locationId && start_datetime === periodStart;
  }) || null;
};
exports.findMatchingAppt = findMatchingAppt;
const actions = {
  clearFilters: (0, _xstate.assign)({
    filterBy: () => ({
      timeOfDay: new _set.default(),
      dayOfWeek: new _set.default()
    })
  }),
  clearAllFilters: (0, _xstate.assign)({
    filterBy: () => ({
      timeOfDay: new _set.default(),
      dayOfWeek: new _set.default()
    }),
    filterCount: 0,
    jumpedToDate: null,
    selectedLocationIds: ctx => {
      var _context, _context2;
      return new _set.default(((_context = ctx.locsByAvailability?.bookable) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _map.default)(_context), _context))?.(loc => loc.id) ?? []);
    },
    query: ctx => {
      var _context3, _context4;
      return {
        ...ctx.query,
        locationIds: ((_context3 = ctx.locsByAvailability?.bookable) == null ? void 0 : (0, _bind.default)(_context4 = Function.call).call(_context4, (0, _map.default)(_context3), _context3))?.(loc => loc.id) ?? [],
        timeOfDay: new _set.default(),
        dayOfWeek: new _set.default(),
        periodStart: null
      };
    }
  }),
  setfilterBy: (0, _xstate.assign)({
    filterBy: (ctx, ev) => ({
      ...ctx.filterBy,
      ...ev.data
    })
  }),
  updateQuery: (0, _xstate.assign)({
    query: (ctx, ev) => ({
      ...ctx.query,
      ...ev.data,
      periodStart: ev.data.periodStart || ctx.query.periodStart || null,
      // toggle location id from locationIds ctx based on clicked current location ID
      locationIds: (0, _from.default)((0, _ProviderLocations.toggleLocationInSet)(ctx.query.locationIds, ev.data.currentId))
    }),
    // why? reset locationId when updated
    // we use this id to be checked when render step 2
    // and display booking time slots based on that
    // it should be reset when user clicks on any other location
    locationId: () => null,
    // updateQuery is called for every subsequent data load after inital
    isInitialDataLoadFromPreviousStep: false
  }),
  setFilterCount: (0, _xstate.assign)({
    filterCount: (ctx, ev) => {
      const {
        locationIds,
        periodStart,
        dayOfWeek,
        timeOfDay
      } = ev.data;
      let filterCount = 0;
      if (locationIds.length !== (ctx.locsByAvailability?.bookable?.length ?? 0)) {
        filterCount++;
      }
      if (periodStart) {
        filterCount++;
      }
      if (dayOfWeek.size > 0 && dayOfWeek.size !== _WeekDayFilter.DAYS_OF_WEEK.length) {
        filterCount++;
      }
      if (timeOfDay.size > 0 && timeOfDay.size !== (0, _keys.default)(_TimeFilter.TIME_OF_DAY).length) {
        filterCount++;
      }
      return filterCount;
    }
  }),
  setAppointments: (0, _xstate.assign)({
    appointments: (ctx, ev) => ev.data.schedRes,
    lastApptQueriedFor: (ctx, ev) => ev.data.lastApptQueriedFor
  }),
  addAppointments: (0, _xstate.assign)((ctx, ev) => {
    // Merge because of how the api time windowing works.
    // We may get an appointment at the head of new list that is the same
    // as the last appointment from the current list
    const mergedAppointments = mergeAppointments(ctx.appointments, ev.data.schedRes);
    let firstNewAppointmentId;
    if (mergedAppointments.length > ctx.appointments.length) {
      firstNewAppointmentId = (0, _utils.getApptSlotId)(mergedAppointments[ctx.appointments.length]);
    }
    return {
      firstNewAppointmentId,
      appointments: mergedAppointments,
      lastApptQueriedFor: ev.data.lastApptQueriedFor
    };
  }),
  selectAppointment: (0, _xstate.assign)({
    selectedAppointment: (ctx, ev) => ev.data.appointment
  }),
  selectAppointmentFromList: (0, _xstate.assign)({
    selectedAppointment: (ctx, ev) => findMatchingAppt(ctx, ev)
  }),
  setIsCaptchaVerified: (0, _xstate.assign)((ctx, ev) => {
    return {
      isCaptchaVerified: ev.data
    };
  }),
  sendParentNext: (0, _xstate.sendParent)(ctx => {
    const {
      selectedAppointment
    } = ctx;
    return {
      type: _Actions.NEXT,
      data: {
        selectedAppointment
      }
    };
  }),
  sendParentCaptchaVerified: (0, _xstate.sendParent)(ctx => {
    const {
      isCaptchaVerified
    } = ctx;
    return {
      type: _Actions.CAPTCHA_VERIFIED,
      data: {
        isCaptchaVerified
      }
    };
  }),
  setLocsByAvailability: (0, _xstate.assign)({
    locsByAvailability: (ctx, ev) => {
      var _context5;
      const {
        provider
      } = ctx;
      const {
        facets
      } = ev.data;
      const {
        terms = []
      } = (0, _find.default)(facets).call(facets, _ref2 => {
        let {
          field
        } = _ref2;
        return field === _Facets.LOCATION_ID;
      }) || {};
      const availableLocs = (0, _reduce.default)(terms).call(terms, (acc, _ref3) => {
        let {
          value: locId,
          count
        } = _ref3;
        if (count > 0) {
          acc.push(locId);
        }
        return acc;
      }, []);
      const locsByAvailability = {
        bookable: [],
        nonBookable: []
      };
      (0, _forEach.default)(_context5 = provider.locations).call(_context5, location => {
        if ((0, _includes.default)(availableLocs).call(availableLocs, location.id)) {
          locsByAvailability.bookable.push(location);
        } else {
          locsByAvailability.nonBookable.push(location);
        }
      });
      return locsByAvailability;
    }
  }),
  setQueryAvailableLocationIds: (0, _xstate.assign)({
    query: ctx => {
      var _context6, _context7, _context8;
      const {
        locsByAvailability,
        locationId,
        selectedLocationIds
      } = ctx;
      // update locationIds in ctx on first load of apptTime step
      let locationIds = (0, _includes.default)(_context6 = (0, _map.default)(_context7 = locsByAvailability.bookable).call(_context7, loc => `${loc.id}`)).call(_context6, locationId) ? [(0, _parseInt2.default)(locationId, 10)] : (0, _map.default)(_context8 = locsByAvailability.bookable).call(_context8, loc => loc.id);
      // If there already are selectedLocationIds, make sure we de-select
      if (selectedLocationIds.size) {
        locationIds = (0, _filter.default)(locationIds).call(locationIds, el => selectedLocationIds.has(el));
      }
      return {
        ...ctx.query,
        locationIds
      };
    }
  }),
  setJumpedToDate: (0, _xstate.assign)({
    jumpedToDate: (ctx, ev) => {
      return ev.data.periodStart;
    }
  }),
  setAltProviders: (0, _xstate.assign)({
    altProviders: (_ctx, ev) => {
      return ev.data;
    }
  }),
  /**
   * Reset deep linking location params when the location filters are interacted with
   */
  sendParentResetLocationFilter: (0, _xstate.sendParent)(_ctx => {
    return {
      type: _Actions.RESET_LOCATION_FILTER
    };
  }),
  clearFiltersOnParent: (0, _xstate.sendParent)((_, _ref4) => {
    let {
      type
    } = _ref4;
    const data = {
      timeOfDay: new _set.default(),
      dayOfWeek: new _set.default()
    };
    // Sent from CollapsibleFilters. Can't clear these fields otherwise.
    if (type === _Actions.CLEAR_ALL_FILTERS) {
      (0, _assign.default)(data, {
        selectedLocationIds: new _set.default(),
        jumpedToDate: ''
      });
    }
    return {
      type: _Actions.SET_FILTERS_ON_PARENT,
      data
    };
  }),
  // NOTE this should always be called last because it is expecting the context to be updated already
  setFiltersOnParent: (0, _xstate.sendParent)(_ref5 => {
    let {
      filterBy,
      query,
      jumpedToDate
    } = _ref5;
    return {
      type: _Actions.SET_FILTERS_ON_PARENT,
      data: {
        ...filterBy,
        selectedLocationIds: new _set.default(query.locationIds || []),
        jumpedToDate
      }
    };
  })
};
const guards = {
  /* no results if no appoinment data comes back OR we have no bookable locations (slots mismatch) */
  hasNoResults: (ctx, ev) => !ev.data || (0, _isEmpty2.default)(ev.data) || ev.data.length === 0 || ctx.locsByAvailability.bookable.length === 0,
  periodStartAndLocationIdInCtxIsAvailable: (ctx, ev) => !!findMatchingAppt(ctx, ev),
  /* locationId exists in context only when deepLinked*/
  periodStartUnavailableAndLocationIdExistsInCtx: (ctx, ev) => {
    const {
      locationId,
      periodStart
    } = ctx;
    if (locationId && periodStart) {
      const appointments = ev.data.schedRes;
      return !(0, _some.default)(appointments).call(appointments, _ref6 => {
        let {
          location_id,
          start_datetime
        } = _ref6;
        return location_id.toString() === locationId && start_datetime === periodStart;
      });
    }
    return false;
  },
  isCaptchaNotVerifiedCtx: ctx => !ctx.isCaptchaVerified,
  isCaptchaNotVerifiedSession: (_ctx, ev) => {
    return !ev.data;
  }
};
const services = {
  getAppointments: (ctx, ev) => {
    const api = new _api.Api(ctx.customerCode);

    /** if deepLinking or jumpToDate,
     *  call /scheduling/list directly with ctx.query.periodStart as start_datetime */
    if (ctx.query.periodStart && ev.type !== _Actions.LOAD_MORE) {
      return api.getScheduling(schedulingParamsFromCtx(ctx, ev));
    }

    /** if loading the page from the previous step or loading more results,
     *  call /availability/next then use next availability start_datetime to call /scheduling/list */
    return api.getNextSchedulingList({
      params: schedulingParamsFromCtx(ctx, ev),
      isInitialLoad: ctx.isInitialDataLoadFromPreviousStep
    });
  },
  getAvailableLocs(ctx) {
    const {
      provider,
      query: {
        patientRel,
        purpose
      },
      customerCode,
      productName,
      visibility
    } = ctx;
    const api = new _api.Api(customerCode, productName);
    return api.getAvailableLocsForProvider(provider.id, {
      patientRel,
      purpose: purpose.name
    }, visibility.role);
  },
  checkCaptchaVerified: async ctx => {
    const api = new _api.Api(ctx.customerCode);
    const res = await api.checkCaptcha();
    return res.verified;
  },
  getAltProviders: async ctx => {
    const {
      customerCode,
      provider,
      locations,
      services
    } = ctx;
    const {
      getAltProviders
    } = services;

    // TODO this locations data comes from the provider, NOT the user selection.. should that change? (https://kyruus.jira.com/browse/KENG-36496)
    const api = new _api.Api(customerCode);
    return getAltProviders ? await api.getAltProvidersData(getAltProviders, provider, locations) : null;
  }
};

// This is exposed for snapshot testing
const machineJSON = _ref7 => {
  let {
    provider,
    locations,
    appointmentQuery,
    periodStart,
    locationId,
    isCaptchaVerified,
    customerCode,
    csrfToken,
    visibility,
    services,
    productName,
    apptTimeFilters = {}
  } = _ref7;
  // fitlers from a previous instance
  const {
    selectedLocationIds,
    timeOfDay,
    dayOfWeek,
    jumpedToDate
  } = apptTimeFilters;
  return {
    id: `Machine__${_States.apptTime}`,
    initial: _States.fetchingAltProviders,
    context: {
      altProviders: [],
      provider,
      locations,
      appointments: [],
      selectedAppointment: null,
      selectedLocationIds: new _set.default(selectedLocationIds),
      filterBy: {
        timeOfDay: new _set.default(timeOfDay),
        dayOfWeek: new _set.default(dayOfWeek)
      },
      query: {
        periodStart,
        patientRel: appointmentQuery.patientRel,
        purpose: appointmentQuery.purpose,
        locationIds: null,
        visibility: [visibility.schedulingVisibility],
        role: visibility.role
      },
      locsByAvailability: {
        bookable: [],
        nonBookable: []
      },
      locationId,
      periodStart,
      isCaptchaVerified,
      customerCode,
      csrfToken,
      visibility,
      /** date jumped to by the user; to be displayed in the UI */
      jumpedToDate: jumpedToDate || '',
      /** Flag to indicate inital load of scheduling data for the page when user is navigating through the flow naturally (not deep linking, loading more results, or jumping to a date).
       *  If deep linking, `periodStart` will be initially defined and `isInitialDataLoadFromPreviousStep` will be false.
       *  If loading more results, the `updateQuery` action will be called which sets `isInitialDataLoadFromPreviousStep` to false. */
      isInitialDataLoadFromPreviousStep: Boolean(periodStart) === true ? false : true,
      services,
      productName,
      filterCount: 0
    },
    on: {
      [_Actions.UPDATE_APPT_QUERY]: {
        actions: ['updateQuery', 'setFiltersOnParent'],
        target: _States.newSearch
      },
      [_Actions.JUMP_TO_DATE]: {
        actions: ['updateQuery', 'setJumpedToDate', 'setFiltersOnParent'],
        target: _States.jumpToDate
      },
      [_Actions.SET_ALL_FILTERS]: {
        actions: ['updateQuery', 'setJumpedToDate', 'setfilterBy', 'setFiltersOnParent', 'setFilterCount'],
        target: _States.jumpToDate
      },
      [_Actions.CLEAR_ALL_FILTERS]: {
        actions: ['clearAllFilters', 'clearFiltersOnParent'],
        target: _States.newSearch
      },
      [_Actions.RESET_LOCATION_FILTER]: {
        actions: ['sendParentResetLocationFilter']
      }
    },
    states: {
      [_States.fetchingAltProviders]: {
        initial: _States.pending,
        states: {
          [_States.pending]: {
            invoke: {
              src: 'getAltProviders',
              onDone: {
                actions: ['setAltProviders'],
                target: _States.done
              },
              // error is not fatal here, page can continue
              onError: _States.done
            }
          },
          [_States.done]: {
            type: 'final'
          }
        },
        onDone: _States.loadingAvailableLocs
      },
      [_States.loadingAvailableLocs]: {
        initial: _States.pending,
        states: {
          [_States.pending]: {
            invoke: {
              src: 'getAvailableLocs',
              onDone: {
                actions: ['setLocsByAvailability', 'setQueryAvailableLocationIds'],
                target: _States.done
              },
              onError: _States.loadingAvailableLocsError
            }
          },
          [_States.done]: {
            type: 'final'
          },
          [_States.loadingAvailableLocsError]: {}
        },
        onDone: _States.newSearch
      },
      [_States.newSearch]: {
        initial: _States.routing,
        on: {
          [_Actions.SELECT_APPOINTMENT]: [{
            actions: ['selectAppointment', 'sendParentNext'],
            target: _States.done
          }]
        },
        states: {
          [_States.routing]: {
            always: [{
              cond: 'isCaptchaNotVerifiedCtx',
              target: _States.checkingCaptchaSession
            }, {
              target: _States.pending
            }]
          },
          [_States.checkingCaptchaSession]: {
            invoke: {
              id: 'checkingCaptchaVerified',
              src: 'checkCaptchaVerified',
              onDone: [{
                cond: 'isCaptchaNotVerifiedSession',
                target: _States.verifyingCaptcha
              }, {
                actions: ['setIsCaptchaVerified', 'sendParentCaptchaVerified'],
                target: _States.pending
              }],
              onError: _States.verifyingCaptcha
            }
          },
          [_States.verifyingCaptcha]: {
            on: {
              [_Actions.CAPTCHA_CANCELLED]: {
                target: _States.routing
              },
              [_Actions.CAPTCHA_VERIFIED]: [{
                actions: ['setIsCaptchaVerified', 'sendParentCaptchaVerified'],
                target: _States.pending
              }],
              [_Actions.CAPTCHA_ERROR]: {
                target: _States.verifyingCaptchaError
              }
            }
          },
          [_States.verifyingCaptchaError]: {
            on: {
              [_Actions.CAPTCHA_RESET]: {
                target: _States.checkingCaptchaSession
              },
              [_Actions.CAPTCHA_CANCELLED]: {
                target: _States.routing
              }
            }
          },
          [_States.success]: {
            on: {
              [_Actions.LOAD_MORE]: {
                target: _States.done,
                actions: 'updateQuery'
              },
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          [_States.deepLinkingTimeSlotUnavailableError]: {
            on: {
              [_Actions.LOAD_MORE]: {
                target: _States.done,
                actions: 'updateQuery'
              },
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          [_States.noResults]: {},
          [_States.pending]: {
            invoke: {
              id: 'getAppointments.newSearch',
              src: 'getAppointments',
              onDone: [{
                cond: 'hasNoResults',
                target: _States.noResults
              }, {
                cond: 'periodStartAndLocationIdInCtxIsAvailable',
                actions: ['selectAppointmentFromList', 'sendParentNext']
              }, {
                cond: 'periodStartUnavailableAndLocationIdExistsInCtx',
                actions: 'setAppointments',
                target: _States.deepLinkingTimeSlotUnavailableError
              }, {
                actions: 'setAppointments',
                target: _States.success
              }],
              onError: _States.noResults
            }
          },
          [_States.done]: {
            type: 'final'
          }
        },
        onDone: _States.nextSearch
      },
      [_States.jumpToDate]: {
        initial: _States.pending,
        on: {
          [_Actions.SELECT_APPOINTMENT]: [{
            actions: ['selectAppointment', 'sendParentNext'],
            target: _States.done
          }]
        },
        states: {
          [_States.success]: {
            on: {
              [_Actions.LOAD_MORE]: {
                target: _States.done,
                actions: 'updateQuery'
              },
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          // NOTE:
          // we're in a `noResults` substate of the `jumpToDate` state
          // which means we already have appointments loaded on the page,
          // but then "jumped" to a date with no results.
          [_States.noResults]: {
            on: {
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          [_States.pending]: {
            invoke: {
              id: 'getAppointments.newSearch',
              src: 'getAppointments',
              onDone: [{
                cond: 'hasNoResults',
                target: _States.noResults
              }, {
                actions: 'setAppointments',
                target: _States.success
              }],
              onError: _States.noResults
            }
          },
          [_States.done]: {
            type: 'final'
          }
        },
        onDone: _States.nextSearch
      },
      [_States.nextSearch]: {
        initial: _States.pending,
        on: {
          [_Actions.SELECT_APPOINTMENT]: [{
            actions: ['selectAppointment', 'sendParentNext'],
            target: _States.done
          }]
        },
        states: {
          [_States.success]: {
            on: {
              [_Actions.LOAD_MORE]: {
                target: _States.pending,
                actions: 'updateQuery'
              },
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          // NOTE:
          // we're in a `noResults` from the `nextSearch` state
          // which means we're on page 2 or greater of the list.
          // So there are appointments already loaded on the page
          [_States.noResults]: {
            on: {
              [_Actions.CLEAR_FILTERS]: {
                actions: ['clearFilters', 'clearFiltersOnParent']
              },
              [_Actions.SET_LOCAL_FILTER]: {
                actions: ['setfilterBy', 'setFiltersOnParent']
              }
            }
          },
          [_States.pending]: {
            invoke: {
              id: 'getAppointments.nextSearch',
              src: 'getAppointments',
              onDone: [{
                cond: 'hasNoResults',
                target: _States.noResults
              }, {
                actions: 'addAppointments',
                target: _States.success
              }],
              onError: _States.noResults
            }
          }
        }
      },
      [_States.done]: {
        type: 'final'
      }
    }
  };
};
exports.machineJSON = machineJSON;
const createApptTimeMachine = _ref8 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref8;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createApptTimeMachine = createApptTimeMachine;
const makeConfig = () => ({
  services,
  actions,
  guards
});
exports.makeConfig = makeConfig;